import { createStyles } from "@mantine/core";

export const useCanadianFirstTemplateStyles = createStyles({
    page: {
        boxShadow: '0px 0px 13px 10px whitesmoke'
    }
})